/* eslint-disable prettier/prettier */
import { useNavigate } from 'react-router-dom';
import { BookCopy, BookType, Calendar1, FileUp, Forward, Shield, Users } from 'lucide-react';
import { FeatureCard } from '../../components/ui/FeatureCard';

export const CompanySettingsPage = () => {
  const navigate = useNavigate();
  const compareTools = [
    {
      icon: <Users />,
      title: 'Users ',
      description: 'Manage and view all users in your company account',
      path: '/company-settings/users',
    },
    {
      icon: <Forward />,
      title: 'Invitations',
      description: 'Send, track, and manage user invitations',
      path: '/company-settings/invitations',
    },
    {
      icon: <Shield />,
      title: 'Roles',
      description: 'Define and assign roles with specific permissions',
      path: '/company-settings/roles',
    },
    {
      icon: <BookType />,
      title: 'Program Definition',
      description: 'Set default fields used to group treaties for this company',
      path: '/company-settings/program-definition',
    },
    {
      icon: <FileUp />,
      title: 'Cedants & Brokers',
      description: 'Upload or remove cedants and brokers sheets',
      path: '/company-settings/cedants-brokers',
    },
  ];

  return (
    <div>
      <h1 className="text-4xl font-bold text-center sm:text-left text-primary">Company Settings</h1>
      <div className="flex flex-col gap-6 pt-7">
        {compareTools.map((tool, index) => (
          <FeatureCard
            key={index}
            icon={tool.icon}
            description={tool.description}
            title={tool.title}
            onClick={() => navigate(tool.path)}
          />
        ))}
      </div>
    </div>
  );
};
